import axios from 'axios'
import moment from 'moment'
import {cloneDeep} from 'lodash'
import getApiClient from '@/plugins/api-client'
import {cnpj, cpf} from 'cpf-cnpj-validator'
import ibgeCityService from '@/services/ibgeCityService'
import {accentInsensitiveFilter, highlightParts} from '@/helpers/textNormalizerHelper'

export default {
    cityFilter: accentInsensitiveFilter,

    cityHighlight: highlightParts,

    setFormattedUserBirthDate: function (rawDate) {
        if (rawDate) {
            this.formattedUserBirthDate = moment(rawDate).format('DD/MM/YYYY')
        }
    },
    loadCitiesForState: async function (uf, callback = null) {
        const self = this
        if (!uf) {
            self.availableCities = []
            return
        }
        self.isLoadingCities = true
        const api = getApiClient(self.$store)
        const cities = await ibgeCityService.getCitiesByUf(api, uf)
        self.availableCities = cities
        self.isLoadingCities = false
        if (typeof callback === 'function') {
            callback(cities)
        }
    },
    loadCompanyCitiesForState: async function (uf, callback = null) {
        const self = this
        if (!uf) {
            self.availableCompanyCities = []
            return
        }
        self.isLoadingCompanyCities = true
        const api = getApiClient(self.$store)
        const cities = await ibgeCityService.getCitiesByUf(api, uf)
        self.availableCompanyCities = cities
        self.isLoadingCompanyCities = false
        if (typeof callback === 'function') {
            callback(cities)
        }
    },
    onStateChange: function (newState) {
        const self = this
        if (!newState) {
            self.availableCities = []
            self.user.address.city = ''
            return
        }
        self.loadCitiesForState(newState, (cities) => {
            if (self.user.address.city && !cities.includes(self.user.address.city)) {
                self.user.address.city = ''
            }
        })
    },
    onCompanyStateChange: function (newState) {
        const self = this
        if (!newState) {
            self.availableCompanyCities = []
            self.user.company.address.city = ''
            return
        }
        self.loadCompanyCitiesForState(newState, (cities) => {
            if (self.user.company.address.city && !cities.includes(self.user.company.address.city)) {
                self.user.company.address.city = ''
            }
        })
    },
    loadCurrentUserData: function () {
        const self = this,
            api = getApiClient(self.$store),
            user = self.$store.state.session.user

        const r = (Math.random() + 1).toString(36).substring(7);
        api.get(`users/${user.id}?${r}`)
            .then((result) => {
                self.user = self.normalizeUserData(result.data)
                if (self.user.address && self.user.address.state) {
                    self.loadCitiesForState(self.user.address.state)
                }
                if (self.user.company && self.user.company.address && self.user.company.address.state) {
                    self.loadCompanyCitiesForState(self.user.company.address.state)
                }
                if (self.user.cpf) {
                    self.isRegistered = true
                }
                self.$store.commit('setUserData', self.user)
            })
    },

    setUserBirthDate: function () {
        let birthDate = this.formattedUserBirthDate.split('/'),
            year = birthDate[2],
            month = birthDate[1],
            day = birthDate[0]

        let formattedDate = `${year}-${month}-${day}`

        if (moment(formattedDate).isValid()) {
            this.user.birthDate = formattedDate
        } else {
            this.formattedUserBirthDate = ''
        }
    },

    loadAddressByZipCode: function (target) {
        const self = this,
            zipCode = target.zipCode.replace(/[^0-9]/g, ''),
            endpoint = `https://viacep.com.br/ws/${zipCode}/json/`

        if (zipCode.length === 8) {
            self.$store.commit('startLoading')
            axios.get(endpoint)
                .then((result) => {
                    let data = result.data
                    if (data && !data.erro) {
                        target.street = data.logradouro || target.street
                        target.neighbourhood = data.bairro || target.neighbourhood
                        target.state = data.uf
                        if (data.uf) {
                            const isCompany = target === self.user.company.address
                            const loader = isCompany ? self.loadCompanyCitiesForState : self.loadCitiesForState
                            loader(data.uf, (cities) => {
                                if (data.localidade) {
                                    const matched = (cities || []).find(c => c.localeCompare(data.localidade, undefined, { sensitivity: 'accent' }) === 0)
                                        || (cities || []).find(c => c.localeCompare(data.localidade, undefined, { sensitivity: 'base' }) === 0)
                                    target.city = matched || ''
                                } else {
                                    target.city = ''
                                }
                            })
                        } else {
                            target.city = ''
                        }
                    }
                })
                .catch(() => {
                })
                .finally(() => {
                    self.$store.commit('stopLoading')
                })
        }
    },

    updatePersonalData: function () {
        const self = this,
            api = getApiClient(self.$store),
            user = self.$store.state.session.user,
            route = self.$route.name

        if (!self.user.cpf && !self.user.company.cnpj) {
            self.showCpfCnpjRequired = true
            return
        }
        self.resetFormMessages()

        let postData = self.reduceUserPostData(),
            params = ''

        if (route === 'ContractorRegister') {
            params = '?newUser=true'
        }

        api.patch(`contractor/register/${user.id}${params}`, postData, {
            headers: {
                'Content-Type': 'application/merge-patch+json'
            }
        })
            .then((result) => {
                let data = result.data
                if (data.address) {
                    self.user.address['@id'] = data.address['@id']
                }
                if (data.company) {
                    self.user.company['@id'] = data.company['@id']
                }
                self.user.password = ''
                self.user.passwordConfirmation = ''

                self.isRegistered = true
                self.$store.commit('setUserData', data)
                self.showSuccessMessage('Dados salvos!')
                if (self.$route.name === 'ContractorRegister') {
                    self.$router.push({
                        name: 'ContractorAccountHome'
                    })
                }
            })
            .catch((error) => {
                let response = error.response
                switch (response.status) {
                    case 400:
                    case 422:
                        if (error.response.data.violations) {
                            error.response.data.violations.forEach((violation) => {
                                self.errors[violation.propertyPath] = violation.message
                            })

                            if (['xs', 'sm'].includes(self.$vuetify.breakpoint.name)) {
                                window.setTimeout(() => {
                                    const firstError = document.querySelector('.v-messages.error--text:first-of-type')
                                    if (firstError) {
                                        let top = firstError.offsetTop
                                        self.$vuetify.goTo(top)
                                    }
                                }, 250)
                            }
                        }
                        break;
                }
                self.showErrorMessage('Falha ao salvar os dados. Verifique os campos e tente novamente.')
            })
    },

    resetFormMessages: function () {
        const self = this
        Object.keys(self.errors).forEach((error) => {
            self.errors[error] = ''
        })
    },

    reduceUserPostData: function () {
        const self = this,
            user = self.user,
            postData = cloneDeep(user)

        if (!postData.birthDate) {
            postData.birthDate = new Date()
        }

        if (!postData.cpf) {
            delete postData.cpf
        }

        if (postData.address['@id']) {
            postData.address.id = postData.address['@id']
        }

        if (postData.company['@id']) {
            postData.company.id = postData.company['@id']
        }

        if (!postData.address.zipCode) {
            delete postData['address']
        }

        if (!postData.company.name && !postData.company.cnpj) {
            delete postData['company']
        }

        if ((postData.photo && !postData.photo.match(/base64/g)) || !postData.photo) {
            self.$delete(postData, 'photo')
        }

        if (!postData.password) {
            self.$delete(postData, 'password')
            self.$delete(postData, 'passwordConfirmation')
        }

        return postData
    },

    normalizeUserData: function (userData) {
        const self = this,
            user = self.user,
            localData = cloneDeep(user),
            mergedObject = Object.assign(localData, userData)

        self.setFormattedUserBirthDate(mergedObject.birthDate)

        return mergedObject
    },

    showErrorMessage: function (message) {
        const self = this

        self.errorMessage.content = message
        self.errorMessage.show = true
    },

    showSuccessMessage: function (message) {
        const self = this

        self.successMessage.content = message
        self.successMessage.show = true
    },

    validateCpf: function (value) {
        if (value && value.length === 14) {
            return cpf.isValid(value) ? true : 'CPF inválido'
        }

        return true
    },

    validateCnpj: function (value) {
        if (value && value.length === 18) {
            return cnpj.isValid(value) ? true : 'CNPJ inválido'
        }

        return true
    }
}
